"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlashNotificationCloseButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Icon_1 = require("@smartsuite/react-ui/lib/components/utils/Icon/Icon");
function FlashNotificationCloseButton({ closeToast, }) {
    return ((0, jsx_runtime_1.jsx)("button", { className: "flash-notification-close-button", onClick: closeToast, children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { size: "S", name: "close", color: "currentColor" }) }));
}
exports.FlashNotificationCloseButton = FlashNotificationCloseButton;
